export const LIST_PATH = "/final-inspection";
export const ADD_PATH = "/final-inspection/add";
export const EDIT_PATH = "/final-inspection/edit";

export const DATE_FORMAT = "YYYY-MM-DD";
export const DISPLAY_DATE_FORMAT = "DD-MMM-YYYY";

export const STYLE_PAGE_SIZE = 20;
export const STYLE_SEARCH_DEBOUNCE_MS = 300;
export const LIST_PAGE_SIZE_OPTIONS = ["10", "20", "50", "100"];
export const DEFAULT_LIST_PAGE_SIZE = 10;

export const INSPECTION_STATUS_OPTIONS = [
  { value: "Passed", label: "Passed" },
  { value: "Failed", label: "Failed" },
];
